var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M504,156c-4.418,0-8,3.582-8,8v216c0,22.056-17.944,40-40,40H56c-22.056,0-40-17.944-40-40V164c0-4.418-3.582-8-8-8 s-8,3.582-8,8v216c0,30.878,25.122,56,56,56h400c30.878,0,56-25.122,56-56V164C512,159.582,508.418,156,504,156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.552,141.231L7.552,141.231l218.089,140.703c9.221,5.949,19.79,8.924,30.359,8.924s21.138-2.975,30.359-8.924 l218.089-140.703c5.055-3.26,7.849-8.865,7.292-14.626c-1.331-13.756-7.729-26.511-18.018-35.917C483.36,81.217,469.964,76,456,76 H56c-13.964,0-27.36,5.217-37.722,14.689C7.989,100.094,1.59,112.85,0.26,126.606C-0.297,132.367,2.497,137.971,7.552,141.231z  M56,92h400c20.244,0,37.645,15.69,39.778,35.784c-0.001,0.001-0.002,0.001-0.003,0.002l-218.09,140.703 c-13.174,8.499-30.196,8.499-43.37,0L16.225,127.786c0,0.001-0.002-0.001-0.003-0.002C18.355,107.689,35.756,92,56,92z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.786e2657.svg";
export { ForwardRef as ReactComponent };